import { store } from '@src/store';

export const elasticApmTags = {
  EAPM_TRANSACTION_SUCCESS: (data) => {
    const state = store.getState();
    const { optumId, userUUID, firstName, lastName } = state.user;
    return {
      event: 'eapm-api-transaction',
      data: {
        result: 'success',
        appVersion: process.env.PACKAGE_VERSION,
        url: window.location.href,
        endpoint: data.endpoint,
        uuid: userUUID,
        optumId,
        duration: data.duration,
        username: `${firstName} ${lastName}`,
        status: data.status,
      },
    };
  },
  EAPM_TRANSACTION_ERROR: (data) => {
    const state = store.getState();
    const { optumId, userUUID, firstName, lastName } = state.user;
    return {
      event: 'eapm-api-transaction',
      data: {
        result: 'error',
        appVersion: process.env.PACKAGE_VERSION,
        url: window.location.href,
        uuid: userUUID,
        optumId,
        duration: data.duration,
        username: `${firstName} ${lastName}`,
        endpoint: data.endpoint,
        code: data.code,
        message: data.message,
      },
    };
  },

  EAPM_TRANSACTION_CONTINUE: (data) => {
    const state = store.getState();
    const { optumId, uuid, firstName, lastName } = state.user;
    return {
      event: 'eapm-continue-event',
      data: {
        result: data.action,
        uuid,
        optumId,
        username: `${firstName} ${lastName}`,
        appVersion: process.env.PACKAGE_VERSION,
        url: window.location.href,
      },
    };
  },
};
